import type { ScoresEveryDay, ScoresEveryDayBrandRangeValues } from "../../../types/scores";
import type { ScoreDailyAverageResponse } from "../response.types";

/**
 * Maps raw per-model daily score rows into `dailyAverageModel` chart state + per-day range extrema.
 * Shape: `scoresByModel[modelId][brandId].scores`.
 */
export function reduceModelScoreDailyRowsToSeries(rows: ScoreDailyAverageResponse[]): {
  scoresByModel: ScoresEveryDay;
  rangeValues: ScoresEveryDayBrandRangeValues;
} {
  const rangeValues: ScoresEveryDayBrandRangeValues = {};

  const scoresByModel = rows.reduce((acc: ScoresEveryDay, score: ScoreDailyAverageResponse) => {
    const modelKey = String(score.model_id);
    const brandKey = String(score.brand_id);

    if (!acc[modelKey]) acc[modelKey] = {};
    if (!acc[modelKey][brandKey]) acc[modelKey][brandKey] = { scores: [] };

    const visibility = Math.round(score.avg_visibility_score);
    const sentiment = Math.round(score.avg_sentiment_score);
    const ranking = score.avg_position;
    const date = score.date;

    if (!rangeValues[date]) {
      rangeValues[date] = {
        visibility: { min: Infinity, max: -Infinity },
        segment: { min: Infinity, max: -Infinity },
      };
    }

    rangeValues[date].visibility.min = Math.min(rangeValues[date].visibility.min, visibility);
    rangeValues[date].visibility.max = Math.max(rangeValues[date].visibility.max, visibility);
    rangeValues[date].segment.min = Math.min(rangeValues[date].segment.min, sentiment);
    rangeValues[date].segment.max = Math.max(rangeValues[date].segment.max, sentiment);

    acc[modelKey][brandKey].scores.push({
      created_at: score.date,
      visibility,
      sentiment,
      ranking,
    });

    return acc;
  }, {});

  return { scoresByModel, rangeValues };
}
